import React, { useState, useRef, useEffect } from "react"
import { NumericFormat as NumberFormat } from "react-number-format"
import Link from "next/link"

import Highlight from "@/components/core/Highlight/Highlight"
import { getPDPUrl } from "@/utils/helper"
import MissingImage from "@/public/images/image-missing.png"

const SliderProductCard = ({
  i18n,
  product,
  currencySign,
  presetConfigs,
  swatchUrl,
  parent,
  title,
  brandName,
  skuId = "",
}) => {
  const [productCardWidth, setProductCardWidth] = useState(0)
  const [pdpNavigationURL, setPdpNavigationURL] = useState("")
  const productCardRef = useRef()
  const presetConfigObject = presetConfigs
  const newTab = false

  useEffect(() => {
    setProductCardWidth(productCardRef.current.clientWidth)
  })

  useEffect(() => {
    if (product) {
      getPDPUrl(product?.productCategory, product?.slug).then(ret =>
        setPdpNavigationURL(ret)
      )
    }
  }, [product])

  const formatUrl = (uUrl, iWidth) => {
    const sUrlPath = uUrl.split("/")
    const sUrlId = sUrlPath[sUrlPath.length - 1]

    let sPreset = ""
    if (iWidth <= 167) {
      sPreset = presetConfigObject?.MobileLandscape ?? ""
    } else if (iWidth <= 458) {
      sPreset = presetConfigObject?.Desktop ?? ""
    } else {
      sPreset = presetConfigObject?.MobilePortrait ?? ""
    }

    return `${swatchUrl}${presetConfigObject.PotraitCategory}?$product_src=is{PAWEB/${sUrlId}}&?${sPreset}`
  }

  const getProductName = () => {
    if (!parent && title) {
      return title
    }
    return product.name || brandName
      ? product.name || brandName
      : product.name
      ? product.name
      : product.description
  }

  return (
    <div ref={productCardRef} className="product-card">
      <Link
        prefetch={false}
        href={
          product ? pdpNavigationURL + (skuId ? `?skuId=${skuId}` : "") : ""
        }
        target={newTab ? "_blank" : "_self"}
        className="product-card__link"
      >
        <div className="product-card__img-container">
          <img
            src={
              product
                ? presetConfigObject
                  ? formatUrl(product.images, productCardWidth)
                  : product.images
                : MissingImage.src
            }
            className="product-card__img"
            alt=""
          />
        </div>
        <div className="product-card__details">
          <div className="product-card__left">
            <h4 className={`product-card__name${!parent ? " default" : ""}`}>
              {<Highlight text={product ? getProductName() : "..."} />}
            </h4>
          </div>
          <div className="product-card__right">
            <b className={`product-card__price${!parent ? " default" : ""}`}>
              <NumberFormat
                value={
                  product
                    ? product.discountedPrice > 0
                      ? product.discountedPrice
                      : product.price
                    : "0"
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </b>
          </div>
        </div>
        <div className="product-card__details">
          <div className="product-card__left">
            <p className="product-card-desc">
              {product
                ? product.name || title || brandName
                  ? product.description
                  : ""
                : ""}
            </p>
          </div>
          <div className="product-card__right">
            {product ? (
              product.discountedPrice !== product.price &&
              product.discountedPrice > 0 && (
                <p className="product-card__discount-price">
                  <NumberFormat
                    value={product.price ?? 0}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </p>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="product-card__details">
          <div className="product-card__left">
            <div className="product-card__color-text">
              <span>
                {product
                  ? product.colors.length > 1
                    ? `${product.colors.length} ${i18n.recentlyViewedColors}`
                    : `1 ${i18n.recentlyViewedColor}`
                  : `1 Color`}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default SliderProductCard
